export default __webpack_public_path__ + "static/media/intro.6d2f0ff8.mp4";